import * as types from "../../constants/ComponentConstants";

//todo memoize all
export function getFilesComponentProps(title, componentName, downloadUrl, documents, isDownloadOnly, onDrop, onDelete, fileTypes, center, validationMessageType, validationMessage, color, size) {

    const mappedOnDrop = (componentName) => {
        return (files) => onDrop(componentName, files);
    };

    const mappedOnDelete = (componentName) => {
        return (file) => onDelete(componentName, file);
    };

    return {
        title: title,
        componentName: componentName,
        color: color ? color : types.COLOR_BLUE,
        fileTypes: isDownloadOnly || !fileTypes ? null : fileTypes,
        downloadFileUrl: downloadUrl,
        files: getFiles(documents, componentName),
        onDrop: isDownloadOnly ? null : mappedOnDrop(componentName),
        onDelete: isDownloadOnly ? null : mappedOnDelete(componentName),
        isDownloadOnly: isDownloadOnly,
        center: center === undefined || !center ? false : center,
        validationMessageType: validationMessageType,
        validationMessage: validationMessage,
        size: size === undefined ? null : size,
        pollingEnabled: false
    };
}

export function getPollingProps(times, minFiles, isPolling, componentName) {
    return {
        pollingEnabled: true,
        minFiles: minFiles,
        pollTimes: times,
        isLoading: isPolling,
        componentName: componentName
    };
}

export function getFiles(documents, componentName, year) {
    let files = documents[componentName] ? documents[componentName] : [];
    if (year) {
        files = documents[componentName + year] ? documents[componentName + year] : [];
    }
    return files;
}

export function formatFilesForSave(documents, baseUrl) {
    let formattedFoldersWithDocuments = Object.keys(documents).map(k => {
        return ({
            files: documents[k].map(fn => {
                return {
                    name: fn,
                    path: baseUrl + "/" + k
                };
            }),
            name: k,
            path: baseUrl
        });
    });

    return formattedFoldersWithDocuments;
}

// *********** the files are stored as properties on a model, no file session is used
export function getPropertyFilesComponentProps(title, propertyName, downloadUrl, fileProperty, originalFiles, isDownloadOnly, onDrop, onDelete, onChange, fileTypes, center, validationMessageType, validationMessage, color, size, tooltipIconColor) {

    const mappedOnDrop = (propertyName) => {
        return (files) => onDrop(propertyName, files);
    };

    const mappedOnDelete = (propertyName) => {
        return (file) => onDelete(propertyName, file);
    };

    return {
        title: title,
        componentName: propertyName,
        color: color ? color : types.COLOR_BLUE,
        fileTypes: isDownloadOnly || !fileTypes ? null : fileTypes,
        downloadFileUrl: downloadUrl,
        files: Array.isArray(fileProperty) ? fileProperty.map(x => x.name) : fileProperty ? [fileProperty] : [],
        originalFiles: originalFiles,
        onDrop: isDownloadOnly ? null : mappedOnDrop(propertyName),
        onDelete: isDownloadOnly ? null : mappedOnDelete(propertyName),
        isDownloadOnly: isDownloadOnly,
        center: center === undefined || !center ? false : center,
        validationMessageType: validationMessageType,
        validationMessage: validationMessage,
        size: size === undefined ? null : size,
        pollingEnabled: false,
        onChange: onChange,
        tooltipIconColor: tooltipIconColor
    };
}

export function onDropFiles(filesProperty, name, droppedFiles) {
    return {
        target: {
            name: name,
            value: mergeFiles(filesProperty, droppedFiles)
        }
    };
}

function mergeFiles(source1, source2) {
    return [...source1.filter(file => !source2.map(x => x.name).includes(file.name)), ...source2];
}

export function onRemoveFile(filesProperty, name, droppedFileName) {
    return {
        target: {
            name: name,
            value: filesProperty.filter(x => x.name !== droppedFileName)
        }
    };
}

//check if file arrays are equal by name and size
export function filesArraysDiffer(source1, source2) {
    if (source1.length !== source2.length)
        return true;

    let result = false;
    source1.some(s => {
        if (!source2.find(f => f.name === s)) {
            result = true;
            return true; //jump out
        }
    });

    return result;
}
// ***********